/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react/button-has-type */
/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/function-component-definition */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { Image, Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import PropTypes, { bool } from 'prop-types';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { faQrcode } from '@fortawesome/free-solid-svg-icons';
import { SpinnerDotted } from 'spinners-react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useForm } from 'react-hook-form';
import { LOADER_COLOR, LOADER_SIZE } from '../../constants/loaderConstants';
import { TableContext } from '../../contexts/tableContext';
import styles from './AttendeeCustomTable.module.scss';
import { getCookies } from '../../hooks/useCookies';
import searchImg from '../../assets/search.svg';
import Paginations from '../Pagination/AttendeePagination';
import noresults from '../../assets/noresults.svg';
import {
  REACT_APP_API_FETCH_BOOKED_USERS,
  SERVER_BASE_URL,
  SERVER_URL_WEB,
} from '../../redux/apiConstants';
import { CapitalizeFirstLetter, DateFormatter } from '../../utilityFunctions/utilsFunctions';
import { createExcelReport, fetchAndDownloadExportLogs } from '../../utils/eventOrderExport';
import ExportToExcel from '../Export/ExportToExcel';
import CancelTicket from '../CancelTicket/CancelTicket';
import VerifyModal from '../VerifyModal/VerifyModal';
import PaymentSettingsModal from '../PaymentSettingsModal/PaymentSettingsModal';
import { Entry } from '../../redux/entrySlice';
import ConfirmAlertPopup from '../ConfirmAlertPopUp/ConfirmAlert';
import InstructionsModal from '../InstructionsModal/InstructionsModal';
import OnboardExpress from '../Onboard/OnBoard';
import PayPalOnboard from '../PaypalOnboard/PayPalOnboard';

const AttendeeCustomTable = React.memo(({ section = 'shows' }) => {
  let url;
  const {
    register,
    handleSubmit,
    reset,
    control,
    // formState: { errors },
  } = useForm();
  const { dashboardStyle, setDashboardHeader } = useContext(TableContext);
  const navigate = useNavigate();
  const params = useParams();
  const { bodyStyle } = useContext(TableContext);
  const [addButtonPermissions, setAddButtonPermissions] = useState({});
  const { searchboxStyle } = useContext(TableContext);
  const { tableheadStyle } = useContext(TableContext);
  const [tableData, setTableData] = useState([]);
  const [eventData, setEventData] = useState();
  const dispatch = useDispatch();
  const { pageNumView, setPageNumView } = useContext(TableContext);
  const [pageNum, setPageNum] = useState(1);
  // new
  const tablelength = tableData.length;
  const [checkedState, setCheckedState] = useState(new Array(tablelength).fill(false));
  const [checkedAll, setCheckedAll] = useState(false);
  const token = `Bearer ${getCookies('Token')}`;
  const [paginationData, setPaginationData] = useState([
    { page: 0, totalResult: 0, totalPages: 0 },
  ]);
  const [search, setSearchTerm] = useState(null);
  const [timer, setTimer] = useState(null);
  const [columns, setColumns] = useState([]);
  const [tableConfig, setTableConfig] = useState();
  const [deletedData, setDeletedData] = useState(null);
  const [refreshData, setRefreshData] = useState(false);
  const [selected, setselected] = useState([]);
  const [details, setDetails] = useState();
  const [stats, setStats] = useState();
  const [tableLoading, setTableLoading] = useState(true);
  const [reportLoading, setReportLoading] = useState(false);
  const [failedReportLoading, setFailedReportLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [modal, setModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [verifyModal, setVerifyModal] = useState(false);
  const [bookingToggleLoading, setBookingToggleLoading] = useState(false);
  const [PaymentShow, setPaymentShow] = useState(false);
  const [instructions, setInstructions] = useState(false);
  const dataPerPage = 10;

  const getUsers = async () => {
    setTableLoading(true);
    const currentPage = pageNumView || pageNum;
    url = `${REACT_APP_API_FETCH_BOOKED_USERS}/${params.eventId}?`;
    url += `page=${currentPage}&limit=${dataPerPage}`;
    if (search !== null) {
      url += `&searchBy=${search}`;
    }
    try {
      const resp = await axios.get(url, {
        method: 'GET',
        headers: { Authorization: token },
      });
      if (resp.status === 200) {
        const response = resp.data.data.event;
        setTableData(response.results);
        setEventData(resp.data.data.show);
        const showData = resp.data.data.show;
        reset({
          publishablekey: showData?.stripePublicKey || '',
          secretKey: showData?.stripeSecretKey || '',
          webhookSecretKey: showData?.stripeWebhookKey || '',
          convinienceFee: showData?.convinienceFee ?? '',
          extraFee: showData?.extraFee ?? '',
          feeType: showData?.convinienceFeeType,
          feeFor: showData?.convinienceFeeFor,
        });
        console.log(resp.data.data);
        setStats(resp.data.data.stats);
        setPaginationData({
          page: response.page,
          totalResult: response.totalResults,
          totalPages: response.totalPages,
        });
        if (pageNumView) {
          setPageNum(response.page);
          setPageNumView(null);
        } else if (response.page !== pageNum) {
          setPageNum(response.page);
        }
        const { Displayfields } = response;
        if (Array.isArray(Displayfields)) {
          setColumns(Displayfields);
        } else {
          const colkeys = Object.keys(Displayfields);
          setTableConfig(Displayfields);
          setColumns(colkeys);
        }
      }
    } catch (err) {
      console.error('Error fetching users:', err);
    } finally {
      setTableLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage !== pageNum) {
      setPageNumView(null);
      setPageNum(newPage);
    }
  };

  useEffect(() => {
    setSearchTerm(null);
    if (!pageNumView) {
      setPageNum(1);
    }
  }, []);

  useEffect(() => {
    setDashboardHeader('');
    const temp = section.replace(/\s+/g, '').toLowerCase();
    const permissions = getCookies('USERPERMISSION');
    permissions.forEach((val) => {
      if (val.section.toLowerCase() === temp) {
        setAddButtonPermissions({
          view: val.view ? val.view : false,
          edit: val.edit ? val.edit : false,
          create: val.create ? val.create : false,
          delete: val.delete ? val.delete : false,
          list: !!(val.view || val.edit || val.create || val.delete),
        });
      } else if (val.submenu) {
        val.submenu.forEach((element) => {
          if (element.section.toLowerCase() === temp) {
            setAddButtonPermissions({
              view: element.view ? element.view : false,
              edit: element.edit ? element.edit : false,
              create: element.create ? element.create : false,
              delete: element.delete ? element.delete : false,
              list: !!(element.view || element.edit || element.create || element.delete),
            });
          }
        });
      }
    });
    getUsers();
    const newarray = [];
    if (checkedAll) {
      for (let i = 0; i < tableData.length; i += 1) {
        newarray.push(tableData[i].id);
        checkedState[i] = true;
      }
      setselected(newarray);
    } else {
      for (let i = 0; i < tableData.length; i += 1) {
        checkedState[i] = false;
      }
      setselected([]);
    }
  }, [pageNum, search, deletedData, refreshData]);

  const onFilterTextChange = (e) => {
    const even = e;
    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }
    setTimer(
      setTimeout(() => {
        const { value } = even.target;
        if (value.length > 0) {
          setPageNum(1);
          setSearchTerm(even.target.value.trim());
        } else {
          setSearchTerm(null);
        }
      }, 1000)
    );
  };

  const confirmDelete = async () => {
    setDeleteLoading(true);

    try {
      const response = await axios.post(
        `${SERVER_BASE_URL}/booking/cancel-booking/${
          details?.ticketId?.id || details?.ticketId?._id
        }`,
        {
          cancelledBy: getCookies('USERID'),
        },
        {
          headers: {
            Authorization: `Bearer ${getCookies('Token')}`,
          },
        }
      );

      if (response.data.code === 200) {
        if (eventData?.eventType === 'form') {
          toast.success('Booking has been cancelled.');
        } else {
          toast.success('Ticket has been cancelled.');
        }
        setDeletedData(details?.ticketId);
        setDeleteLoading(false);
        setDeleteModal(false);
      } else {
        toast.error('Something went wrong.');
        setDeleteModal(false);
        setDeleteLoading(false);
      }
    } catch (error) {
      toast.error('Something went wrong.');
      setDeleteModal(false);
      setDeleteLoading(false);
    }
  };

  const confirmEnable = () => {
    setDeleteLoading(true);
    const actionData = {};
    if (details?.qrEnabled) {
      actionData.actionUrl = `shows/disable-qr/${details?.id}`;
    } else {
      actionData.actionUrl = `shows/enable-qr/${details?.id}`;
    }
    actionData.actionMethod = 'get';
    dispatch(Entry(actionData)).then((resp) => {
      if (resp.payload.code === 200) {
        if (resp?.payload?.data?.show?.qrEnabled) {
          toast.success('QR Scanner has been enabled!');
        } else {
          toast.success('QR Scanner has been disabled!');
        }
        setDeletedData(details?.qrEnabled);
        setDeleteLoading(false);
        setModal(false);
      } else {
        toast.error('Something went wrong.');
        setModal(false);
        setDeleteLoading(false);
      }
    });
  };

  const verifyTicket = () => {
    setDeleteLoading(true);
    const actionData = {};
    actionData.actionUrl = `shows/verify-ticket`;
    actionData.actionMethod = 'post';
    actionData.apiData = {
      ticketId: details?.id || details?._id,
      eventId: eventData?.id || eventData?._id,
    };
    console.log(actionData);
    dispatch(Entry(actionData)).then((resp) => {
      if (resp.payload.code === 200) {
        toast.success('Ticket has been verified.');
        setDeletedData(details?.ticketId);
        setDeleteLoading(false);
        setVerifyModal(false);
      } else {
        toast.error('Something went wrong.');
        setVerifyModal(false);
        setDeleteLoading(false);
      }
    });
  };

  function handleDelete(e, ticket) {
    setDetails(ticket);
    setDeleteModal(true);
  }

  function handleVerify(e, ticket) {
    setDetails(ticket);
    setVerifyModal(true);
  }
  function handleModal() {
    setModal(true);
    setDetails(eventData);
  }

  const supportsBookingPause = ['form', 'booking', 'non-seat-booking', 'rsvp'].includes(
    (eventData?.eventType || '').toLowerCase()
  );
  const isLiveOrUpcomingStatus = ['created', 'in progress'].includes(eventData?.status);
  const canPauseBooking =
    supportsBookingPause &&
    isLiveOrUpcomingStatus &&
    !eventData?.bookingPaused &&
    eventData?.bookingStatus !== 'ended';
  const canResumeBooking = eventData?.bookingPaused === true;

  const handleToggleBookingPause = async (action) => {
    const evId = eventData?.id || eventData?._id;
    if (!evId) return;
    setBookingToggleLoading(true);
    try {
      const endpoint =
        action === 'pause'
          ? `${SERVER_BASE_URL}/shows/pause-booking/${evId}`
          : `${SERVER_BASE_URL}/shows/resume-booking/${evId}`;
      const { data } = await axios.post(endpoint, {}, { headers: { Authorization: token } });
      const updatedShow = data?.data?.show;
      if (updatedShow) {
        setEventData((prev) => ({ ...prev, ...updatedShow }));
      }
      toast.success(action === 'pause' ? 'Booking paused.' : 'Booking resumed.');
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Failed to update booking status.');
    } finally {
      setBookingToggleLoading(false);
    }
  };

  const handleDeleteClose = () => setDeleteModal(false);
  const handleVerifyClose = () => setVerifyModal(false);
  const handleModalClose = () => setModal(false);
  const handleInstructionsClose = () => setInstructions(false);

  const actionView = (e, param) => {
    const encodeText = param.id;
    setPageNumView(pageNum);
    navigate(`/shows/view-ticket/${encodeText}`);
  };

  const onSubmit = (data) => {
    console.log('Form submitted:', data);
    setDeleteLoading(true);
    const actionData = {};
    actionData.actionUrl = `shows/${eventData?.id}`;
    actionData.actionMethod = 'patch';
    actionData.apiData = {
      stripePublicKey:
        data?.publishablekey === '' ? eventData?.stripePublicKey : data?.publishablekey,
      stripeSecretKey: data?.secretKey === '' ? eventData?.stripeSecretKey : data?.secretKey,
      stripeWebhookKey:
        data?.webhookSecretKey === '' ? eventData?.stripeWebhookKey : data?.secretKey,
      convinienceFee:
        data?.convinienceFee === '' ? eventData?.convinienceFee : data?.convinienceFee,
      extraFee:
        data?.feeType === 'both'
          ? data?.extraFee === '' || data?.extraFee == null
            ? eventData?.extraFee ?? null
            : Number(data.extraFee)
          : null,
      convinienceFeeType: data?.feeType === '' ? eventData?.convinienceFeeType : data?.feeType,
      convinienceFeeFor: data?.feeFor === '' ? eventData?.convinienceFeeFor : data?.feeFor,
    };
    dispatch(Entry(actionData)).then((resp) => {
      if (resp.payload.code === 200) {
        toast.success('Payment details are updated successfully.');
        setDeleteLoading(false);
        setRefreshData(!refreshData);
        setPaymentShow(false);
        reset();
      } else {
        toast.error('Something went wrong.');
        setPaymentShow(false);
        reset();
        setDeleteLoading(false);
      }
    });
  };

  const exportStats = async (eventId) => {
    try {
      setReportLoading(true);
      const response = await fetch(`${SERVER_BASE_URL}/shows/bookings-stats-report/${eventId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getCookies('Token')}`,
        },
      });
      const data = await response.json();
      if (data.code === 200) {
        const mergedStats = { ...(data.data.stats || {}), ...(stats || {}) };
        createExcelReport({ ...data.data, stats: mergedStats });
        toast.success('Report downloaded successfully!');
      } else {
        toast.error('Failed to fetch report data');
      }
    } catch (error) {
      toast.error('Error generating report');
    } finally {
      setReportLoading(false);
    }
  };

  const exportLogs = async (eventId) => {
    try {
      setFailedReportLoading(true);
      const result = await fetchAndDownloadExportLogs({
        eventId,
        eventType: eventData?.eventType,
        eventName: eventData?.eventName || 'Event',
        authorization: `Bearer ${getCookies('Token')}`,
        baseUrl: SERVER_BASE_URL,
      });
      if (result.empty) {
        if (result.type === 'audit') {
          toast.info('No audit logs found for this event.');
        } else {
          toast.info('No abandoned bookings found for this event.');
        }
        return;
      }
      toast.success(
        result.type === 'audit'
          ? 'Audit log report downloaded!'
          : 'Pending tickets report downloaded!'
      );
    } catch (error) {
      toast.error(error?.message || 'Error generating log report');
    } finally {
      setFailedReportLoading(false);
    }
  };

  return (
    <div className={styles[bodyStyle]}>
      <InstructionsModal show={instructions} handleClose={handleInstructionsClose} />
      <PaymentSettingsModal
        show={PaymentShow}
        onHide={() => {
          reset();
          setPaymentShow(false);
        }}
        control={control}
        register={register}
        webhookUrl={`${SERVER_URL_WEB}/webhook-event/${encodeURIComponent(eventData?.eventName)}`}
        onSubmit={handleSubmit(onSubmit)}
        loading={deleteLoading}
      />

      <CancelTicket
        show={deleteModal}
        handleClose={handleDeleteClose}
        onConfirm={confirmDelete}
        onCancel={handleDeleteClose}
        message="Do you really want to cancel this ticket? "
        loading={deleteLoading}
      />
      <ConfirmAlertPopup
        show={modal}
        handleClose={handleModalClose}
        onConfirm={confirmEnable}
        onCancel={handleModalClose}
        message={
          eventData?.qrEnabled
            ? 'Are you sure to disable QR scanner?'
            : 'Are you sure to enable QR scanner?'
        }
        loading={deleteLoading}
      />
      <VerifyModal
        show={verifyModal}
        handleClose={handleVerifyClose}
        onConfirm={verifyTicket}
        onCancel={handleVerifyClose}
        loading={deleteLoading}
      />
      {addButtonPermissions.list && (
        <div
          className={styles[dashboardStyle]}
          style={{ minHeight: '100vh' }}
          id={styles.dashboardcont2}
        >
          <div className="container-fluid" id={styles.container}>
            <div className={styles.user_tb_hd}>
              <div className={styles.userhd}>
                <div
                  value="Back"
                  onClick={() => {
                    navigate(-1);
                  }}
                  className={`${styles.arrowback} backBtn`}
                >
                  <svg
                    className="mr-1"
                    width="17"
                    height="14"
                    viewBox="0 0 17 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.5 6.00003H3.64L7.27 1.64003C7.43974 1.43581 7.5214 1.17253 7.49702 0.908108C7.47264 0.643682 7.34422 0.39977 7.14 0.230032C6.93578 0.060293 6.6725 -0.0213689 6.40808 0.0030108C6.14365 0.0273905 5.89974 0.155815 5.73 0.360032L0.73 6.36003C0.696361 6.40776 0.666279 6.45789 0.64 6.51003C0.64 6.56003 0.64 6.59003 0.57 6.64003C0.524674 6.75469 0.500941 6.87674 0.5 7.00003C0.500941 7.12332 0.524674 7.24537 0.57 7.36003C0.57 7.41003 0.57 7.44003 0.64 7.49003C0.666279 7.54217 0.696361 7.59231 0.73 7.64003L5.73 13.64C5.82402 13.7529 5.94176 13.8437 6.07485 13.9059C6.20793 13.9681 6.35309 14.0003 6.5 14C6.73365 14.0005 6.96009 13.9191 7.14 13.77C7.24126 13.6861 7.32496 13.583 7.38631 13.4666C7.44766 13.3503 7.48546 13.223 7.49754 13.092C7.50961 12.961 7.49573 12.829 7.45669 12.7034C7.41764 12.5777 7.3542 12.4611 7.27 12.36L3.64 8.00003H15.5C15.7652 8.00003 16.0196 7.89467 16.2071 7.70714C16.3946 7.5196 16.5 7.26525 16.5 7.00003C16.5 6.73482 16.3946 6.48046 16.2071 6.29292C16.0196 6.10539 15.7652 6.00003 15.5 6.00003Z"
                      fill=""
                    />
                  </svg>
                  Back
                </div>
                <div className={styles.info_contain}>
                  <div className={styles.info_content}>
                    <p>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_8817_38163)">
                          <path
                            d="M11.3366 14.0909C11.1322 14.11 10.9269 14.0638 10.7503 13.9591C10.6212 13.8266 10.5593 13.6426 10.5821 13.4591C10.5869 13.3062 10.6051 13.1541 10.6366 13.0045C10.6671 12.8329 10.7066 12.663 10.7548 12.4954L11.2912 10.65C11.3465 10.4678 11.383 10.2805 11.4003 10.0909C11.4003 9.88632 11.4275 9.74539 11.4275 9.66359C11.4389 9.29902 11.2833 8.94918 11.0048 8.71359C10.6623 8.45062 10.2357 8.32136 9.80481 8.34996C9.49602 8.35461 9.18961 8.40515 8.8957 8.49996C8.57449 8.59996 8.2366 8.71964 7.88207 8.85906L7.72754 9.45906C7.83207 9.42269 7.95938 9.38179 8.1048 9.33632C8.24355 9.29523 8.38738 9.27378 8.53207 9.27269C8.73504 9.2507 8.93934 9.30054 9.10934 9.41359C9.22481 9.55136 9.27898 9.73035 9.25934 9.90906C9.25883 10.0619 9.24207 10.2143 9.20934 10.3636C9.1775 10.5227 9.1366 10.6909 9.0866 10.8681L8.5457 12.7227C8.50211 12.895 8.46723 13.0695 8.44117 13.2454C8.41992 13.396 8.4093 13.5478 8.40934 13.6999C8.40711 14.067 8.57496 14.4144 8.86387 14.6408C9.21168 14.9079 9.64434 15.0403 10.082 15.0136C10.3902 15.0199 10.6974 14.9753 10.9911 14.8817C11.2487 14.7938 11.5927 14.6681 12.023 14.5044L12.1684 13.9317C12.0519 13.9801 11.9318 14.0196 11.8093 14.0499C11.6544 14.0853 11.4954 14.099 11.3366 14.0909Z"
                            fill="#0C5460"
                          />
                          <path
                            d="M11.9041 5.3409C11.6568 5.11372 11.3308 4.99149 10.995 5C10.6594 4.99243 10.3338 5.11454 10.0859 5.3409C9.63156 5.7327 9.58081 6.41868 9.97265 6.87309C10.0076 6.9136 10.0454 6.95145 10.0859 6.98637C10.6036 7.44938 11.3865 7.44938 11.9041 6.98637C12.3585 6.59071 12.4061 5.90165 12.0104 5.44727C11.9775 5.40942 11.942 5.37387 11.9041 5.3409Z"
                            fill="#0C5460"
                          />
                          <path
                            d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5229 4.47715 20 10 20C15.5229 20 20 15.5229 20 10C20 4.47715 15.5229 0 10 0ZM10 19.0909C4.97922 19.0909 0.909102 15.0208 0.909102 10C0.909102 4.97922 4.97922 0.909102 10 0.909102C15.0208 0.909102 19.0909 4.97922 19.0909 10C19.0909 15.0208 15.0208 19.0909 10 19.0909Z"
                            fill="#0C5460"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_8817_38163">
                            <rect width="20" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>{' '}
                      How can I make a payment using Stripe?
                    </p>
                    <button type="button" onClick={() => setInstructions(true)}>
                      View details
                    </button>
                  </div>
                </div>
              </div>

              {/* <div className={styles.onboardsty}>
                <PayPalOnboard eventId={eventData?.id} />
                <OnboardExpress eventId={eventData?.id} />
              </div> */}
            </div>
            <div className={`${styles.attent_flex_contain} table_top attent_flex`}>
              <div className={`${styles.searchcontainer} ${styles.searchcontainer_inner}`}>
                <div className={`${styles.search_contain_box1} ${styles.count_contain} `}>
                  <div>
                    <h5>{eventData?.eventName}</h5>
                  </div>
                  {!tableLoading && (
                    <div className={styles.tabbtn}>
                      {/* <div className={styles.totalamt1}>
                        <ul>
                          <li>
                            Total Participants: <span>{stats?.totalPeople}</span>
                          </li>
                          <li>
                            Total Adults: <span>{stats?.totalAdults}</span>
                          </li>
                          <li>
                            Total Kids: <span>{stats?.totalKids}</span>
                          </li>
                        </ul>
                      </div>
                      <div className={styles.totalamt}>
                        Total Amount: <span>${stats?.totalAmountPaid}</span>
                      </div>{' '} */}
                      <div className={styles.count_box_contain}>
                        <ul>
                          <li>
                            <div className={styles.count_text}>Total Participants</div>
                            <div className={styles.count_num}>{stats?.totalPeople}</div>
                          </li>
                          <li>
                            <div className={styles.count_text}>Total Adults</div>
                            <div className={styles.count_num}>{stats?.totalAdults}</div>
                          </li>
                          <li>
                            <div className={styles.count_text}>Total Kids</div>
                            <div className={styles.count_num}>{stats?.totalKids}</div>
                          </li>
                          <li>
                            <div className={styles.count_text}>Tickets Booked</div>
                            <div className={styles.count_num}>{stats?.totalBookings}</div>
                          </li>
                          <li>
                            <div className={styles.count_text}>Check-ins</div>
                            <div className={styles.count_num}>
                              {stats?.verifiedTickets}/{stats.totalBookings}
                            </div>
                          </li>
                        </ul>
                        <ul>
                          <li>
                            <div className={styles.count_text}>Online Payments</div>
                            <div className={styles.count_num}>${stats?.totalOnline.toFixed(2)}</div>
                          </li>
                          <li>
                            <div className={styles.count_text}>Platform Fees</div>
                            <div className={styles.count_num}>
                              ${stats?.totalConvinienceFee.toFixed(2)}
                            </div>
                          </li>
                          <li>
                            <div className={styles.count_text}>Payout to Organizer</div>
                            <div className={styles.count_num}>${stats?.payOut.toFixed(2)}</div>
                          </li>
                          <li>
                            <div className={styles.count_text}>Cash Collected</div>
                            <div className={styles.count_num}>${stats?.totalCash.toFixed(2)}</div>
                          </li>
                          <li>
                            <div className={styles.count_text}>Total Revenue</div>
                            <div className={styles.count_num}>
                              ${stats?.totalAmountPaid.toFixed(2)}
                            </div>
                          </li>
                        </ul>
                        <ul>
                          <li>
                            <div className={styles.count_text}>Total Stripe Payment</div>
                            <div className={styles.count_num}>${stats?.totalStripe.toFixed(2)}</div>
                          </li>
                          <li>
                            <div className={styles.count_text}>Total Paypal Payments</div>
                            <div className={styles.count_num}>${stats?.totalPaypal.toFixed(2)}</div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
                <div className={styles.search_contain_box}>
                  <div>
                    <div className={`${styles.search_contain} search_contain`}>
                      <Image src={searchImg} alt="search" />
                      <input
                        className={`${styles[searchboxStyle]} searchbar`}
                        type="search"
                        onChange={onFilterTextChange}
                        placeholder="Search by Name"
                        // value={search}
                      />
                      <div
                        className={tableLoading ? 'spinner-border spinner-border-sm' : ''}
                        id={styles.spinner}
                        role="status"
                      >
                        {/* <span className="sr-only">Loading...</span> */}
                      </div>
                    </div>
                  </div>
                  <div className={styles.tabbtn}>
                    {/* {!tableLoading && eventData?.status !== 'ended' && (
                      <button className="addBtnyellow pay_btn" onClick={() => setPaymentShow(true)}>
                        <svg
                          width="18"
                          height="19"
                          viewBox="0 0 18 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M16.7142 7.78571C16.5427 7.18571 16.1999 6.58571 15.5999 6.24285L7.54274 1.27142C6.34274 0.499996 4.79988 0.928568 4.02845 2.12857L0.942735 7.27142C0.171307 8.47142 0.599878 10.0143 1.79988 10.7857L2.91416 11.4714V15.5C2.91416 16.8714 4.02845 18.0714 5.48559 18.0714H14.8284C16.1999 18.0714 17.3999 16.9571 17.3999 15.5V9.5C17.3999 8.81428 17.1427 8.21428 16.7142 7.78571ZM14.9142 8.72857C15.3427 8.72857 15.7713 9.07143 15.7713 9.58571V13.0143H4.62845V9.58571C4.62845 9.15714 4.97131 8.72857 5.48559 8.72857H14.9142ZM2.39988 8.12857L5.48559 3.07142C5.74274 2.64285 6.25702 2.55714 6.68559 2.81428L13.5427 7.01428H5.48559C4.11416 7.01428 2.99988 8.12857 2.91416 9.5L2.65702 9.32857C2.31416 9.07142 2.14274 8.55714 2.39988 8.12857ZM14.9142 16.3571H5.48559C5.05702 16.3571 4.62845 16.0143 4.62845 15.5V14.6429H15.6856V15.5C15.7713 16.0143 15.3427 16.3571 14.9142 16.3571Z"
                            fill="white"
                          />
                          <path
                            d="M12.3425 11.2143H14.0568C14.5711 11.2143 14.9139 10.8714 14.9139 10.3571C14.9139 9.84286 14.5711 9.5 14.0568 9.5H12.3425C11.8282 9.5 11.4854 9.84286 11.4854 10.3571C11.4854 10.8714 11.8282 11.2143 12.3425 11.2143Z"
                            fill="white"
                          />
                        </svg>
                        Payment Settings
                      </button>
                    )} */}

                    {!tableLoading && eventData?.status !== 'ended' && !eventData?.qrEnabled && (
                      <button className="addBtn" type="button" onClick={handleModal}>
                        {' '}
                        <FontAwesomeIcon icon={faQrcode} className="add_icon" />
                        Enable QR Scanner
                      </button>
                    )}
                    {!tableLoading && eventData?.status === 'created' && eventData?.qrEnabled && (
                      <button className="addDltBtn" type="button" onClick={handleModal}>
                        {' '}
                        <FontAwesomeIcon icon={faQrcode} className="add_icon" />
                        Disable QR Scanner
                      </button>
                    )}
                    {!tableLoading && canPauseBooking && (
                      <button
                        className="addDltBtn"
                        type="button"
                        disabled={bookingToggleLoading}
                        onClick={() => handleToggleBookingPause('pause')}
                      >
                        {bookingToggleLoading ? 'Please Wait...' : 'Pause Booking'}
                      </button>
                    )}
                    {!tableLoading && canResumeBooking && (
                      <button
                        className="addBtn"
                        type="button"
                        disabled={bookingToggleLoading}
                        onClick={() => handleToggleBookingPause('resume')}
                      >
                        {bookingToggleLoading ? 'Please Wait...' : 'Resume Booking'}
                      </button>
                    )}
                    {!tableLoading && (
                      <button
                        className={`${styles.export_btn} addBtnyellow`}
                        disabled={reportLoading}
                        onClick={() => exportStats(eventData?.id)}
                        title="Download Report"
                      >
                        <svg
                          width="17"
                          height="19"
                          viewBox="0 0 17 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M16.0773 4.26282L12.3999 0.651062C12.3013 0.554245 12.1686 0.5 12.0303 0.5H2.73328C1.64838 0.5 0.765625 1.38261 0.765625 2.46765V16.5323C0.765625 17.6172 1.64824 18.5 2.73328 18.5H14.2674C15.3523 18.5 16.2351 17.6174 16.2351 16.5323V4.6391C16.2351 4.49751 16.1782 4.36197 16.0773 4.26282ZM12.5577 2.28445L14.4182 4.11176H12.7253C12.6329 4.11176 12.5577 4.0365 12.5577 3.94408V2.28445ZM14.2674 17.4453H2.73328C2.22997 17.4453 1.82031 17.0358 1.82031 16.5323V2.46765C1.82031 1.9642 2.22983 1.55469 2.73328 1.55469H11.5031V3.94408C11.5031 4.61809 12.0515 5.16644 12.7255 5.16644H15.1804V16.5323C15.1804 17.0358 14.7709 17.4453 14.2674 17.4453Z" />
                          <path d="M12.1613 8.86719H4.72742C4.43614 8.86719 4.20007 9.10326 4.20007 9.39453C4.20007 9.68581 4.43614 9.92188 4.72742 9.92188H12.1613C12.4526 9.92188 12.6887 9.68581 12.6887 9.39453C12.6887 9.10326 12.4526 8.86719 12.1613 8.86719Z" />
                          <path d="M4.72742 12.0312H10.7888C11.0801 12.0312 11.3162 11.7952 11.3162 11.5039C11.3162 11.2126 11.0801 10.9766 10.7888 10.9766H4.72742C4.43614 10.9766 4.20007 11.2126 4.20007 11.5039C4.20007 11.7952 4.43614 12.0312 4.72742 12.0312Z" />
                          <path d="M11.5201 13.0859H4.72742C4.43614 13.0859 4.20007 13.322 4.20007 13.6133C4.20007 13.9046 4.43614 14.1406 4.72742 14.1406H11.5201C11.8113 14.1406 12.0475 13.9046 12.0475 13.6133C12.0475 13.322 11.8113 13.0859 11.5201 13.0859Z" />
                        </svg>
                        {reportLoading ? 'Please Wait...' : 'Download'}
                      </button>
                    )}
                    {!tableLoading && (
                      <button
                        className={`${styles.export_btn} addBtnyellow`}
                        disabled={failedReportLoading}
                        onClick={() => exportLogs(eventData?.id)}
                        title="Download Log"
                      >
                        <svg
                          width="17"
                          height="19"
                          viewBox="0 0 17 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M16.0773 4.26282L12.3999 0.651062C12.3013 0.554245 12.1686 0.5 12.0303 0.5H2.73328C1.64838 0.5 0.765625 1.38261 0.765625 2.46765V16.5323C0.765625 17.6172 1.64824 18.5 2.73328 18.5H14.2674C15.3523 18.5 16.2351 17.6174 16.2351 16.5323V4.6391C16.2351 4.49751 16.1782 4.36197 16.0773 4.26282ZM12.5577 2.28445L14.4182 4.11176H12.7253C12.6329 4.11176 12.5577 4.0365 12.5577 3.94408V2.28445ZM14.2674 17.4453H2.73328C2.22997 17.4453 1.82031 17.0358 1.82031 16.5323V2.46765C1.82031 1.9642 2.22983 1.55469 2.73328 1.55469H11.5031V3.94408C11.5031 4.61809 12.0515 5.16644 12.7255 5.16644H15.1804V16.5323C15.1804 17.0358 14.7709 17.4453 14.2674 17.4453Z" />
                          <path d="M12.1613 8.86719H4.72742C4.43614 8.86719 4.20007 9.10326 4.20007 9.39453C4.20007 9.68581 4.43614 9.92188 4.72742 9.92188H12.1613C12.4526 9.92188 12.6887 9.68581 12.6887 9.39453C12.6887 9.10326 12.4526 8.86719 12.1613 8.86719Z" />
                          <path d="M4.72742 12.0312H10.7888C11.0801 12.0312 11.3162 11.7952 11.3162 11.5039C11.3162 11.2126 11.0801 10.9766 10.7888 10.9766H4.72742C4.43614 10.9766 4.20007 11.2126 4.20007 11.5039C4.20007 11.7952 4.43614 12.0312 4.72742 12.0312Z" />
                          <path d="M11.5201 13.0859H4.72742C4.43614 13.0859 4.20007 13.322 4.20007 13.6133C4.20007 13.9046 4.43614 14.1406 4.72742 14.1406H11.5201C11.8113 14.1406 12.0475 13.9046 12.0475 13.6133C12.0475 13.322 11.8113 13.0859 11.5201 13.0859Z" />
                        </svg>
                        {failedReportLoading ? 'Please Wait...' : 'Download Log'}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="table-responsive" style={{ minHeight: '250px' }}>
              <table className={`${styles.table_attendee} table table-borderless`}>
                <thead>
                  <tr className={styles[tableheadStyle]}>
                    {eventData?.eventType !== 'form' && (
                      <th scope="col" style={{ width: '15%' }}>
                        Registered Users
                      </th>
                    )}
                    {eventData?.eventType === 'form' && (
                      <th scope="col" style={{ width: '15%' }}>
                        Attendees
                      </th>
                    )}
                    <th scope="col" style={{ width: '15%' }}>
                      Net Amount
                    </th>
                    {eventData?.isCoupon && (
                      <th scope="col" style={{ width: '15%' }}>
                        Coupon Discount
                      </th>
                    )}
                    <th scope="col" style={{ width: '15%' }}>
                      Paid Amount
                    </th>
                    <th scope="col" style={{ width: '20%' }}>
                      Payment Mode
                    </th>
                    {/* <th scope="col" style={{ width: '20%' }}>
                      Payment Method
                    </th> */}
                    {eventData?.eventType === 'booking' && (
                      <th scope="col" style={{ width: '5%' }}>
                        Seats
                      </th>
                    )}
                    <th scope="col" style={{ width: '20%' }}>
                      Status
                    </th>
                    <th scope="col" style={{ width: '10%' }}>
                      Action
                    </th>
                  </tr>
                </thead>
                {Object.keys(tableData) && !tableLoading ? (
                  <tbody>
                    {tableData.map((item, index) => (
                      <tr>
                        {eventData?.eventType !== 'form' && <td>{item.userName}</td>}
                        {eventData?.eventType === 'form' && <td>{item?.formResponseId?.name}</td>}
                        <td>
                          $
                          {item.ticketId.totalPrice
                            ? item?.ticketId?.totalPrice?.toFixed(2)
                            : '0.00'}
                        </td>
                        {eventData?.isCoupon && (
                          <td>
                            $
                            {item.ticketId.couponDiscount
                              ? item?.ticketId?.couponDiscount?.toFixed(2)
                              : '0.00'}
                          </td>
                        )}
                        <td>
                          $
                          {item.ticketId.totalAmount
                            ? item.ticketId.totalAmount?.toFixed(2)
                            : '0.00'}
                        </td>
                        <td>{CapitalizeFirstLetter(item.ticketId.paymentMethod)}</td>
                        {/* <td>Card Payment</td> */}
                        {eventData?.eventType === 'booking' && <td>{item.seatsBooked}</td>}
                        {item.paymentStatus === 'cancelled' ? (
                          <td>
                            <span style={{ display: 'flex' }}>
                              <svg
                                width="20"
                                height="20"
                                clipRule="evenodd"
                                fillRule="evenodd"
                                imageRendering="optimizeQuality"
                                shapeRendering="geometricPrecision"
                                textRendering="geometricPrecision"
                                viewBox="0 0 21.0001 21.0001"
                                xmlns="http://www.w3.org/2000/svg"
                                id="fi_14090261"
                              >
                                <g id="图层_x0020_1">
                                  <path d="m0 0h21v21h-21z" fill="none" />
                                  <path
                                    d="m10.5 1.3124c5.07328 0 9.1876 4.11432 9.1876 9.1876s-4.11432 9.1876-9.1876 9.1876-9.1876-4.11432-9.1876-9.1876 4.11432-9.1876 9.1876-9.1876zm-3.93814 8.2033h7.87628c.54211 0 .9843.4422.9843.9843 0 .54211-.44367.9843-.9843.9843h-7.87628c-.54063 0-.9843-.4422-.9843-.9843 0-.54211.4422-.9843.9843-.9843z"
                                    fill="#FF0000"
                                  />
                                </g>
                              </svg>
                              <span className={`${styles.ststus_text} ${styles.ststus_cancelled}`}>
                                Cancelled
                              </span>
                              {/* <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <circle cx="12" cy="12" r="12" fill="#FF0000" />
                                <rect
                                  x="6.69922"
                                  y="5"
                                  width="16.9375"
                                  height="2.79"
                                  rx="1.395"
                                  transform="rotate(46.478 6.69922 5)"
                                  fill="white"
                                />
                                <rect
                                  x="5"
                                  y="17.1092"
                                  width="16.9375"
                                  height="2.78807"
                                  rx="1.39404"
                                  transform="rotate(-45 5 17.1092)"
                                  fill="white"
                                />
                              </svg> */}
                            </span>
                          </td>
                        ) : !item.isVerified ? (
                          <td>
                            <span
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                width: 'max-content',
                                alignItems: 'center',
                              }}
                            >
                              {' '}
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_7688_26940)">
                                  <path
                                    d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                                    fill="#C9C7C5"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M8.25143 17.8528L3.86264 13.1555C3.26179 12.5124 3.29628 11.4949 3.93936 10.8941C4.58245 10.2932 5.5999 10.3278 6.20075 10.9708L9.58607 14.594L14.9446 9.5874C14.9928 9.54233 15.0431 9.50104 15.0952 9.46305L17.6151 7.10869C18.2582 6.50784 19.2757 6.54242 19.8765 7.18551C20.4773 7.8285 20.4428 8.84604 19.7998 9.44689L12.1033 16.6379L12.0951 16.6291L9.43281 19.1166L8.25143 17.8528Z"
                                    fill="white"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_7688_26940">
                                    <rect width="24" height="24" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                              <span
                                className={`${styles.ststus_text} ${styles.ststus_not_verified}`}
                              >
                                Not Verified
                              </span>
                            </span>
                          </td>
                        ) : (
                          <td>
                            <span>
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_7688_26945)">
                                  <path
                                    d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                                    fill="#00BA00"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M8.25143 17.8528L3.86264 13.1555C3.26179 12.5124 3.29628 11.4949 3.93936 10.8941C4.58245 10.2932 5.5999 10.3278 6.20075 10.9708L9.58607 14.594L14.9446 9.5874C14.9928 9.54233 15.0431 9.50104 15.0952 9.46305L17.6151 7.10869C18.2582 6.50784 19.2757 6.54242 19.8765 7.18551C20.4773 7.8285 20.4428 8.84604 19.7998 9.44689L12.1033 16.6379L12.0951 16.6291L9.43281 19.1166L8.25143 17.8528Z"
                                    fill="white"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_7688_26945">
                                    <rect width="24" height="24" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                              <span className={`${styles.ststus_text} ${styles.ststus_verified}`}>
                                Verified
                              </span>
                            </span>
                          </td>
                        )}
                        <td>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                            <span className={`${styles.refund}`}>
                              <OverlayTrigger
                                overlay={<Tooltip id="tooltip-disabled">View</Tooltip>}
                              >
                                <Button
                                  className={styles.refund_tooltip}
                                  onClick={(e) => actionView(e, item)}
                                >
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M19.8729 9.61099C19.6942 9.36658 15.4371 3.62637 9.9999 3.62637C4.56274 3.62637 0.305391 9.36658 0.126914 9.61076C-0.0423048 9.84264 -0.0423048 10.1571 0.126914 10.389C0.305391 10.6334 4.56274 16.3736 9.9999 16.3736C15.4371 16.3736 19.6942 10.6334 19.8729 10.3892C20.0423 10.1574 20.0423 9.84264 19.8729 9.61099ZM9.9999 15.055C5.99486 15.055 2.52606 11.2451 1.49922 9.99955C2.52473 8.75295 5.98626 4.94505 9.9999 4.94505C14.0048 4.94505 17.4733 8.75427 18.5006 10.0004C17.4751 11.247 14.0135 15.055 9.9999 15.055Z"
                                      fill="#98999E"
                                    />
                                    <path
                                      d="M10 6.04396C7.81868 6.04396 6.04395 7.81869 6.04395 10C6.04395 12.1814 7.81868 13.9561 10 13.9561C12.1813 13.9561 13.9561 12.1814 13.9561 10C13.9561 7.81869 12.1813 6.04396 10 6.04396ZM10 12.6374C8.54571 12.6374 7.36266 11.4543 7.36266 10C7.36266 8.54576 8.54575 7.36267 10 7.36267C11.4543 7.36267 12.6374 8.54576 12.6374 10C12.6374 11.4543 11.4543 12.6374 10 12.6374Z"
                                      fill="#98999E"
                                    />
                                  </svg>
                                </Button>
                              </OverlayTrigger>
                            </span>
                            {eventData?.status === 'in progress' &&
                              !item?.isVerified &&
                              item?.paymentStatus === 'booked' && (
                                <span className={`${styles.refund}`}>
                                  <OverlayTrigger
                                    overlay={<Tooltip id="tooltip-disabled">Verify</Tooltip>}
                                  >
                                    <Button onClick={(e) => handleVerify(e, item)}>
                                      <span>
                                        <svg
                                          width="18"
                                          height="18"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g clipPath="url(#clip0_7688_26940)">
                                            <path
                                              d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                                              fill="#C9C7C5"
                                            />
                                            <path
                                              fillRule="evenodd"
                                              clipRule="evenodd"
                                              d="M8.25143 17.8528L3.86264 13.1555C3.26179 12.5124 3.29628 11.4949 3.93936 10.8941C4.58245 10.2932 5.5999 10.3278 6.20075 10.9708L9.58607 14.594L14.9446 9.5874C14.9928 9.54233 15.0431 9.50104 15.0952 9.46305L17.6151 7.10869C18.2582 6.50784 19.2757 6.54242 19.8765 7.18551C20.4773 7.8285 20.4428 8.84604 19.7998 9.44689L12.1033 16.6379L12.0951 16.6291L9.43281 19.1166L8.25143 17.8528Z"
                                              fill="white"
                                            />
                                          </g>
                                          <defs>
                                            <clipPath id="clip0_7688_26940">
                                              <rect width="24" height="24" fill="white" />
                                            </clipPath>
                                          </defs>
                                        </svg>
                                      </span>
                                    </Button>
                                  </OverlayTrigger>
                                </span>
                              )}
                            {eventData?.status !== 'ended' &&
                              !item?.isVerified &&
                              item?.paymentStatus === 'booked' && (
                                <span className={`${styles.refund}`}>
                                  <OverlayTrigger
                                    overlay={<Tooltip id="tooltip-disabled">Refund</Tooltip>}
                                  >
                                    <Button onClick={(e) => handleDelete(e, item)}>
                                      {/* <span className={styles.tooltiptext}>Tooltip text</span> */}
                                      <svg
                                        id="fi_4947544"
                                        height="26"
                                        viewBox="0 0 512 512"
                                        width="26"
                                        xmlns="http://www.w3.org/2000/svg"
                                        data-name="Layer 1"
                                      >
                                        <path
                                          d="m457.052 230.633a202.662 202.662 0 0 0 -197.686-177.273l13.9-13.787a10.666 10.666 0 1 0 -15.021-15.146l-33.787 33.513a10.663 10.663 0 0 0 -.062 15.083l33.786 34.065a10.666 10.666 0 1 0 15.146-15.021l-17.228-17.374a181.34 181.34 0 0 1 113.2 322.907 10.667 10.667 0 0 0 13.344 16.646c55.481-44.491 83.299-113.131 74.408-183.613z"
                                          fill="#98999E"
                                        />
                                        <path
                                          d="m253.818 404.911a10.666 10.666 0 1 0 -15.146 15.021l17.228 17.368a181.332 181.332 0 0 1 -113.233-322.87 10.668 10.668 0 0 0 -13.354-16.641c-55.454 44.495-83.256 113.122-74.365 183.576a202.645 202.645 0 0 0 197.692 177.267l-13.906 13.795a10.666 10.666 0 1 0 15.021 15.146l33.786-33.516a10.663 10.663 0 0 0 .063-15.083z"
                                          fill="#98999E"
                                        />
                                        <path
                                          d="m264.469 247.565c-1.516-.581-2.937-1.117-4.161-1.656-1.344-.594-2.953-1.211-4.729-1.885-10.1-3.836-15.578-6.867-15.578-11.885 0-2.216 2.365-5.656 6.88-7.943 3.2-1.617 14.75-6.047 29.469 4.771a10.666 10.666 0 1 0 12.635-17.187 57.463 57.463 0 0 0 -22.318-10.123v-9.657a10.667 10.667 0 0 0 -21.333 0v10.159a42.673 42.673 0 0 0 -8.083 3c-11.464 5.8-18.583 16.138-18.583 26.979 0 20.688 19.813 28.214 29.339 31.831 1.38.521 2.641.995 3.688 1.458 1.526.672 3.281 1.349 5.161 2.068 10.474 4 15.146 6.641 15.146 11.7 0 2.214-2.365 5.656-6.88 7.938-3.2 1.615-14.745 6.052-29.469-4.771a10.666 10.666 0 1 0 -12.635 17.188 57.62 57.62 0 0 0 22.318 10.194v10.256a10.667 10.667 0 0 0 21.333 0v-10.785a42.7 42.7 0 0 0 8.083-3.044c11.464-5.8 18.583-16.135 18.583-26.974-.002-20.603-18.778-27.778-27.778-31.632z"
                                          fill="#98999E"
                                        />
                                        <path
                                          d="m256 138.667a117.333 117.333 0 1 0 117.333 117.333 117.466 117.466 0 0 0 -117.333-117.333zm0 213.333a96 96 0 1 1 96-96 96.112 96.112 0 0 1 -96 96z"
                                          fill="#98999E"
                                        />
                                      </svg>
                                    </Button>
                                  </OverlayTrigger>
                                </span>
                              )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                ) : null}
                {tableData.length === 0 && !tableLoading ? (
                  <tbody>
                    <tr>
                      <td colSpan="7">
                        <div className={styles.norecordsdiv}>
                          <Image src={noresults} alt="" />
                          <h6 className={styles.norecord}>No Items to Display</h6>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                ) : null}
                {tableLoading && (
                  <tbody>
                    <tr>
                      <td colSpan="7">
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: '50px 0',
                          }}
                        >
                          <SpinnerDotted size={LOADER_SIZE} color={LOADER_COLOR} />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                )}
              </table>
            </div>
          </div>
          {!tableLoading && tableData.length !== 0 && (
            <Paginations
              paginationData={paginationData}
              setPageNum={handlePageChange}
              dataName="User"
            />
          )}
        </div>
      )}
    </div>
  );
});

AttendeeCustomTable.propTypes = {
  section: PropTypes.string,
};

AttendeeCustomTable.defaultProps = {
  section: 'User',
};

export default AttendeeCustomTable;
